import './category-icon.style.sass';
import template from './category-icon.tpl.pug';

/* global require */
const iconContext = require.context('./image', false, /\.svg$/);
const iconMap = require('./category-icon-map.json');

const iconIndexMap = iconMap.reduce((map, entry) => {
    if (!entry || !entry.iconIndex) {
        return map;
    }

    if (entry.svgFilename) {
        map[entry.iconIndex] = entry.svgFilename;
        return map;
    }

    if (entry.pdfFilename) {
        map[entry.iconIndex] = entry.pdfFilename.replace(/\.pdf$/i, '.svg');
    }

    return map;
}, {});

function resolveIconPath(name, iconIndex) {
    const mappedName = iconIndexMap[iconIndex];
    const resolvedName = name || mappedName;

    if (!resolvedName) {
        return null;
    }

    const normalized = String(resolvedName).trim();
    if (!normalized) {
        return null;
    }

    const fileName = normalized.endsWith('.svg') ? normalized : `${normalized}.svg`;

    try {
        return iconContext(`./${fileName}`);
    } catch (error) {
        return null;
    }
}

function normalizeSize(size) {
    if (size == null || size === '') {
        return null;
    }

    if (typeof size === 'number') {
        return `${size}px`;
    }

    const value = `${size}`.trim();
    if (!value.length) {
        return null;
    }

    return /^\d+$/.test(value)
        ? `${value}px`
        : value;
}

class CategoryIconController {
    $onChanges(changeObject) {
        if (changeObject.iconName || changeObject.iconIndex) {
            this.iconUrl = resolveIconPath(this.iconName, this.iconIndex);
        }

        if (changeObject.color || changeObject.iconName || changeObject.size) {
            const safeUrl = this.iconUrl ? encodeURI(this.iconUrl).replace(/"/g, '\\"') : null;
            const iconUrl = safeUrl ? `url("${safeUrl}")` : null;
            const size = normalizeSize(this.size);

            this.style = {
                color: this.color || 'currentColor',
                backgroundColor: this.color || 'currentColor',
                maskImage: iconUrl,
                WebkitMaskImage: iconUrl,
                width: size,
                height: size
            };
        }
    }
}

export default {
    selector: 'dbACategoryIcon',
    template: template(),
    controller: CategoryIconController,
    bindings: {
        iconName: '<',
        iconIndex: '<',
        color: '<',
        size: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/category-icon/category-icon.cmpt.js